import React from 'react';
import { TextField } from './index';

const QuantityField = ({ id, className, quantity, pack, onChange }) => {
  let changeDelay = undefined;

  function doChange(target) {
    let { value } = target;

    if (pack && value) {
      if (value % pack !== 0) {
        value = (Math.floor(value/pack) * pack) + pack;
      }
    }

    if (onChange) {
      onChange(id, value);
      quantity = value;
    }
  }

  function handleChange(event) {
    clearTimeout(changeDelay);

    changeDelay = window.setTimeout(doChange, 500, {...event.target});
  }
/*
  function handleChange(event) {
    const { value } = event.target;
    if (value === '0') {
      event.target.value = '';
      return;
    }
    if (!value) return;
    onChange && onChange(id, value);
  }
*/
  function handleBlur(event) {
    event.target.value = quantity;
  }

  function handleKeyPress(event) {
    if (event.key < '0' || event.key > '9') event.preventDefault();
  }

  return (
    <TextField
      style={{ width: '5rem' }}
      className={className}
      defaultValue={quantity}
      onChange={handleChange}
      onBlur={handleBlur}
      onKeyPress={handleKeyPress}
    />
  );
};

export default QuantityField;
